import styles from './ButtonContent.module.css';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon';
import type { IconColours } from '../../Icon/Icon.types';
import type {
  ButtonComponentProps,
  PrimaryVariantProps,
  SecondaryVariantProps,
} from '../Button.types';

const ButtonContent = (
  props: ButtonComponentProps & { noMinWidth?: boolean }
) => {
  const { children, noMinWidth } = props;
  const blockClasses = classNames(styles.ButtonContent, {
    [styles['ButtonContent--no-min-width']]: noMinWidth,
  });

  return (
    <div className={blockClasses}>
      {'icon' in props ? (
        <ButtonContentWithIcon {...props}> {children} </ButtonContentWithIcon>
      ) : (
        children
      )}
    </div>
  );
};

type PrimaryVariantButtonColor = NonNullable<PrimaryVariantProps['color']>;
type SecondaryVariantButtonColor = NonNullable<SecondaryVariantProps['color']>;

interface IconColorMapType {
  primary: Record<PrimaryVariantButtonColor, IconColours>;
  secondary: Record<SecondaryVariantButtonColor, IconColours>;
}

const iconColourMap: IconColorMapType = {
  primary: {
    white: 'black',
    black: 'white',
    green: 'white',
  },
  secondary: {
    black: 'black',
    blue: 'blue',
  },
};

const ButtonContentWithIcon = (props: ButtonComponentProps) => {
  const {
    icon: { name, placement } = { name: '404_FallbackIcon', placement: 'left' },
    color = 'black',
    size = 'medium',
    variant,
    children,
  } = props;

  const iconColor =
    variant === 'primary'
      ? iconColourMap.primary[color as PrimaryVariantButtonColor]
      : iconColourMap.secondary[color as SecondaryVariantButtonColor];
  const iconSize = size === 'small' ? '14px' : '16px';
  const icon = (
    <Icon name={name} width={iconSize} height={iconSize} color={iconColor} />
  );

  if (placement === 'left') {
    return (
      <>
        <div className={styles['ButtonContent__icon-left']}>{icon}</div>
        {children}
      </>
    );
  }

  return (
    <>
      {children}
      <div className={styles['ButtonContent__icon-right']}>{icon}</div>
    </>
  );
};

export default ButtonContent;
